/**
 * 48点データ画面の CSV ダウンロード導線の「有効 / 無効 (+ 無効の理由)」を決める純関数。
 *
 * 無効理由は [[ButtonTooltip]] でボタンに出す。分岐を UI から切り離すことで、
 * 「一覧取得中」「取得失敗」のようにページ経由では組みにくい状態も F1 で固定できる
 * (`SpotBidding/models/spotMenuActionState.ts` と同じ方針)。文言 (i18n key) の
 * 対応は呼び出し側 (Toolbar) が持つ。
 *
 * **0 件と読み取り専用はここに入れない。**
 * - 0 件は「取得できた結果が 0 件」なので出力できる。まだデータの無い受渡日に
 *   ヘッダーのみの雛形を落として書き込むのが本機能の目的の一つ (AC-S4D-007-1)。
 * - ダウンロードは読み取り操作なので確定済み・削除済みケース経由でも塞がない
 *   (`design/CLAUDE.md`)。実際 `isReadonly` は保存 / undo / redo / 自動計算に戻す
 *   の 4 つにしか効いていない。
 */
export type CsvDownloadState = 'active' | 'loading' | 'error'

/**
 * 理由は「取得失敗 → 取得中」の順に返す。取得失敗はリロードや条件変更が要る
 * 終端状態で、待っても解消しないため優先して伝える。
 */
export const resolveCsvDownloadState = ({
  isLoaded,
  hasError,
}: {
  /** 一覧の応答を受け取れているか (`data !== undefined`)。 */
  isLoaded: boolean
  /** 一覧取得がエラーで終わっているか (`listError !== null`)。 */
  hasError: boolean
}): CsvDownloadState => {
  if (hasError) return 'error'
  if (!isLoaded) return 'loading'
  return 'active'
}
